var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C15.6156 0 18.7499 8.24521 18.7499 8.24521C18.7499 8.24521 27.4745 8.71119 27.9737 10.2647C28.473 11.8181 21.6856 17.3799 21.6856 17.3799C21.6856 17.3799 23.9433 25.9131 22.6363 26.8732C21.3292 27.8333 14 23.0255 14 23.0255C14 23.0255 6.67077 27.8333 5.36375 26.8732C4.05673 25.9131 6.31444 17.3799 6.31444 17.3799C6.31444 17.3799 -0.472988 11.8181 0.0262494 10.2647C0.525487 8.71119 9.25006 8.24521 9.25006 8.24521C9.25006 8.24521 12.3844 0 14 0Z",
    fill: "#FFAB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/StarFilled.4e498cd05d91493d7e4275912446f841.svg";
export { ForwardRef as ReactComponent };